module.exports = __webpack_public_path__ + "static/media/Paste.841599da.svg";